<template>
  <v-card outlined class="fill-height d-flex flex-column">
    <div class="d-flex align-center pa-3 pb-1">
      <v-avatar size="32" :color="material.color" class="mr-3 flex-shrink-0" style="border: 1px solid rgba(0, 0, 0, 0.3)" />
      <div class="text-subtitle-2" style="min-width: 0">{{ material.title }}</div>
      <v-spacer />
      <v-chip v-if="material.builtin" x-small class="ml-2 flex-shrink-0">built-in</v-chip>
    </div>
    <v-card-text class="pt-1 flex-grow-1">
      <div class="text-body-2">
        n = <b>{{ material.refraction_index }}</b> · ε = n² = {{ epsilon }}
      </div>
      <div v-if="material.description" class="text-caption mt-1">{{ material.description }}</div>
    </v-card-text>
    <v-card-actions v-if="deletable">
      <v-spacer />
      <v-btn text small color="error" @click="$emit('delete')">
        <v-icon left small>mdi-delete-outline</v-icon> Delete
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
// Cartão de um material na página de materiais
export default {
  name: "MaterialCard",
  props: {
    material: { type: Object, required: true },
    deletable: { type: Boolean, default: false }
  },
  computed: {
    epsilon() {
      const n = Number(this.material.refraction_index);
      return Number((n * n).toFixed(4));
    }
  }
};
</script>
